import React from "react";
import { useTranslation } from "react-i18next";
import { Typography, Paper, Alert } from "@mui/material";

interface AccessDeniedProps {
    featureName: string;
    addonName: string;
}

const AccessDenied: React.FC<AccessDeniedProps> = ({ featureName, addonName }) => {
    const { t: rawT } = useTranslation();
    const t = rawT as any;

    return (
        <div className="access-denied-container" style={{ padding: "20px" }}>
            <Paper
                elevation={2}
                style={{ padding: "150px", textAlign: "center", maxWidth: "600px", margin: "50px auto" }}
            >
                <div style={{ marginBottom: "24px" }}>
                    <div
                        style={{
                            width: "64px",
                            height: "64px",
                            backgroundColor: "#f44336",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            margin: "0 auto 16px auto",
                            color: "white",
                            fontSize: "32px",
                        }}
                    >
                        🔒
                    </div>
                    <Typography variant="h4" style={{ marginBottom: "16px", color: "#333" }}>
                        {t("accessDenied")}
                    </Typography>
                </div>

                <Alert severity="warning" style={{ marginBottom: "24px" }}>
                    <Typography variant="body1">
                        {t("accessDeniedMessage", { feature: featureName, addon: addonName })}
                    </Typography>
                </Alert>

                <Typography variant="body2" color="textSecondary">
                    {t("contactAdministratorForAccess")}
                </Typography>
            </Paper>
        </div>
    );
};

export default AccessDenied;
